// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__C7s6H","title":"ClientInsurance_title__23h9K","itemText":"ClientInsurance_itemText__niczL"};